import useTranslationOrders from 'domains/Orders/useTranslationOrders';

export function useOrdersSubscriptionFilter() {
  const t = useTranslationOrders('filters.isSubscriptionFilter');

  const getSubscriptionFilterOptionTracking = (
    isSubscription?: string,
  ): string => {
    if (isSubscription === '' || isSubscription === undefined) {
      return String(false);
    }
    return isSubscription === 'true' ? 'subscription' : 'unique';
  };

  const filterOptions = [
    {
      label: t('all'),
      value: '',
    },
    {
      label: t('unique'),
      value: 'false',
    },
    {
      label: t('subscription'),
      value: 'true',
    },
  ];

  return {
    getSubscriptionFilterOptionTracking,
    filterOptions,
  };
}
